<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}數字滑桿題
    </template>
    <v-card-text class="text-start" slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <v-slider
        v-model="ques.value"
        :min="ques.miniNum"
        :max="ques.maxiNum"
        :step="ques.numInterval"
        thumb-label="always"
        class="mt-8"
      >
        <template slot="thumb-label">
          {{ ques.value === null ? '?' : ques.value }}
        </template>
      </v-slider>
      <v-input
        :value="ques.value"
        :rules="[
          v => {
            let pass = !(ques.isRequired && !ques.value)
            return pass ? true : '此題為必填'
          }
        ]"
      >
      </v-input>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  mounted() {
    // 這裡要先消除 value，因為 mount 前不明原因會被自動設定為最小值
    // 跟這個 issue 有關：有空再研究： https://github.com/vuetifyjs/vuetify/issues/4746
    this.ques.value = null
  },
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  },
  computed: {
    maxiNum() {
      return this.ques.maxiNum
    },
    miniNum() {
      return this.ques.miniNum
    },
    numInterval() {
      return this.ques.numInterval
    }
  }
}
</script>

<style lang="scss" scoped></style>
